import React from "react"
import styled from "styled-components"
import Header from "~/components/dashboard/Layout/Header/NewFlowHeader"

const Layout = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
`

const LandingLayout = ({ children, inFlow }) => {
  return (
    <Layout>
      <Header inFlow={inFlow} />
      {children}
    </Layout>
  )
}

export default LandingLayout
